import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { AdminSchoolYearService } from '../../../services/admin/admin-school-year.service';
import { AdminSchoolYearResearchExportService } from '../../../services/admin/admin-school-year-research-export.service';
import { SchoolYearModel } from '../../../models/school/school-year.model';
import { SchoolModel } from '../../../models/school/school.model';
import {
  RESEARCH_EXPORT_COLUMNS,
  ResearchExportActivityPeriod,
  ResearchExportColumnGroup,
  ResearchExportPayload,
  ResearchExportScope,
  ResearchExportSkillGranularity
} from '../../../models/school/research-export.model';
import { ModalService } from '../../../shared/modals/modal/modal.service';
import { ErrorModel } from '../../../models/shared/error.model';

type PreviewTab = 'skills' | 'activity' | 'groups';

const PREVIEW_SKILL_ROWS = [
  { student_id: 'STU_4f2a', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', skill_group: 'Count 1-20',    mastery_start: '0.18', mastery_end: '0.62', mastery_delta: '+0.44', first_active_date: '2024-09-02', last_active_date: '2025-05-28', num_days_active: 42, num_answers: 312, num_correct: 246, num_wrong: 66, correct_rate: '79%' },
  { student_id: 'STU_4f2a', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', skill_group: 'Addition 1-10', mastery_start: '0.12', mastery_end: '0.45', mastery_delta: '+0.33', first_active_date: '2024-09-08', last_active_date: '2025-05-20', num_days_active: 38, num_answers: 264, num_correct: 190, num_wrong: 74, correct_rate: '72%' },
  { student_id: 'STU_7c9e', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', skill_group: 'Count 1-20',    mastery_start: '0.22', mastery_end: '0.58', mastery_delta: '+0.36', first_active_date: '2024-09-02', last_active_date: '2025-05-25', num_days_active: 35, num_answers: 280, num_correct: 210, num_wrong: 70, correct_rate: '75%' },
  { student_id: 'STU_7c9e', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', skill_group: 'Subtraction',   mastery_start: '0.08', mastery_end: '0.28', mastery_delta: '+0.20', first_active_date: '2024-10-14', last_active_date: '2025-05-10', num_days_active: 22, num_answers: 142, num_correct: 87,  num_wrong: 55, correct_rate: '61%' },
  { student_id: 'STU_b3e1', school_name: 'Hlíðaskóli',    grade: 2, group_id: 'GRP_3a9d', skill_group: 'Count 1-20',    mastery_start: '0.35', mastery_end: '0.71', mastery_delta: '+0.36', first_active_date: '2024-09-03', last_active_date: '2025-05-22', num_days_active: 38, num_answers: 295, num_correct: 228, num_wrong: 67, correct_rate: '77%' },
];

const PREVIEW_ACTIVITY_ROWS = [
  { student_id: 'STU_4f2a', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', month: '2024-09', num_answers: 88,  num_correct: 64, num_wrong: 24, correct_rate: '73%' },
  { student_id: 'STU_4f2a', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', month: '2024-10', num_answers: 102, num_correct: 80, num_wrong: 22, correct_rate: '78%' },
  { student_id: 'STU_7c9e', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', month: '2024-09', num_answers: 74,  num_correct: 52, num_wrong: 22, correct_rate: '70%' },
  { student_id: 'STU_7c9e', school_name: 'Kópavogsskóli', grade: 1, group_id: 'GRP_8b1c', month: '2024-10', num_answers: 88,  num_correct: 66, num_wrong: 22, correct_rate: '75%' },
  { student_id: 'STU_b3e1', school_name: 'Hlíðaskóli',    grade: 2, group_id: 'GRP_3a9d', month: '2024-09', num_answers: 94,  num_correct: 74, num_wrong: 20, correct_rate: '79%' },
];

const PREVIEW_GROUP_ROWS = [
  { school_name: 'Kópavogsskóli', group_id: 'GRP_8b1c', group_name: 'Grade 1A', grade: 1, skill_group: 'Count 1-20',    mastery_avg_start: '0.20', mastery_avg_end: '0.62', mastery_delta_avg: '+0.42', num_active_students: 24, total_answers: '1,840' },
  { school_name: 'Kópavogsskóli', group_id: 'GRP_8b1c', group_name: 'Grade 1A', grade: 1, skill_group: 'Addition 1-10', mastery_avg_start: '0.14', mastery_avg_end: '0.45', mastery_delta_avg: '+0.31', num_active_students: 22, total_answers: '1,420' },
  { school_name: 'Kópavogsskóli', group_id: 'GRP_8b1c', group_name: 'Grade 1A', grade: 1, skill_group: 'Subtraction',   mastery_avg_start: '0.09', mastery_avg_end: '0.28', mastery_delta_avg: '+0.19', num_active_students: 18, total_answers: '980'  },
  { school_name: 'Hlíðaskóli',    group_id: 'GRP_2d4f', group_name: 'Grade 1',  grade: 1, skill_group: 'Count 1-20',    mastery_avg_start: '0.24', mastery_avg_end: '0.68', mastery_delta_avg: '+0.44', num_active_students: 21, total_answers: '1,620' },
  { school_name: 'Hlíðaskóli',    group_id: 'GRP_2d4f', group_name: 'Grade 1',  grade: 1, skill_group: 'Basic Shapes',  mastery_avg_start: '0.48', mastery_avg_end: '0.76', mastery_delta_avg: '+0.28', num_active_students: 20, total_answers: '1,100' },
];

@Component({
  selector: 'app-admin-school-year-research-export',
  templateUrl: './admin-school-year-research-export.component.html',
  styleUrls: ['./admin-school-year-research-export.component.css']
})
export class AdminSchoolYearResearchExportComponent implements OnInit {

  schoolYear: SchoolYearModel = null;
  schoolYearId: string;
  isLoadingYear = false;
  isLoadingSchools = false;
  isExporting = false;

  allSchools: SchoolModel[] = [];
  selected = new Set<string>();
  scope: ResearchExportScope = 'schools';

  sections = { skills: true, activity: true, groups: true };
  skillGranularity: ResearchExportSkillGranularity = 'skillGroup';
  groupGranularity: ResearchExportSkillGranularity = 'skillGroup';
  activityPeriod: ResearchExportActivityPeriod = 'monthly';

  columnGroups: ResearchExportColumnGroup[] = RESEARCH_EXPORT_COLUMNS;
  selectedColumns: { [key: string]: boolean } = {};

  includeSchoolName = true;
  includeGroupName = true;
  excludeLowActivityStudents = false;

  previewTab: PreviewTab = 'skills';
  previewActivityRows = PREVIEW_ACTIVITY_ROWS;
  previewGroupRows = PREVIEW_GROUP_ROWS;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private schoolYearSv: AdminSchoolYearService,
    private exportSv: AdminSchoolYearResearchExportService,
    private modalSv: ModalService
  ) {
    this.columnGroups.forEach(g => g.items.forEach(c => this.selectedColumns[c.key] = true));
  }

  ngOnInit() {
    this.schoolYearId = this.route.snapshot.params['schoolYearId'];
    this.isLoadingYear = true;
    this.schoolYearSv.getSchoolYear(this.schoolYearId).subscribe(year => {
      this.schoolYear = year;
      this.isLoadingYear = false;
      this.loadSchools();
    }, () => {
      this.isLoadingYear = false;
      this.modalSv.showAlertModal('Error', 'Could not load the school year. Please go back and try again.');
    });
  }

  loadSchools() {
    this.isLoadingSchools = true;
    this.schoolYearSv.getSchoolYearSchools(this.schoolYearId).subscribe(schools => {
      this.allSchools = schools;
      this.selected = new Set(schools.map(s => s._id));
      this.isLoadingSchools = false;
    }, () => {
      this.isLoadingSchools = false;
      this.modalSv.showAlertModal('Error', 'Could not load schools for this school year. Please refresh the page.');
    });
  }

  setScope(scope: ResearchExportScope) {
    this.scope = scope;
  }

  toggleSchool(id: string) {
    if (this.selected.has(id)) {
      this.selected.delete(id);
    } else {
      this.selected.add(id);
    }
  }

  isSelected(id: string): boolean {
    return this.selected.has(id);
  }

  selectAllSchools() {
    this.allSchools.forEach(s => this.selected.add(s._id));
  }

  clearSchools() {
    this.selected.clear();
  }

  toggleSection(name: 'skills' | 'activity' | 'groups') {
    this.sections[name] = !this.sections[name];
  }

  toggleColumn(key: string) {
    const col = this.findColumn(key);
    if (col && col.required) {
      return;
    }
    this.selectedColumns[key] = !this.selectedColumns[key];
  }

  toggleColumnGroup(groupName: string) {
    const group = this.columnGroups.find(g => g.group === groupName);
    if (!group) {
      return;
    }
    const nonRequired = group.items.filter(c => !c.required);
    const allOn = nonRequired.every(c => this.selectedColumns[c.key]);
    nonRequired.forEach(c => this.selectedColumns[c.key] = !allOn);
  }

  columnGroupHasOptionalColumns(groupName: string): boolean {
    const group = this.columnGroups.find(g => g.group === groupName);
    return !!group && group.items.some(c => !c.required);
  }

  isColumnGroupAllOn(groupName: string): boolean {
    const group = this.columnGroups.find(g => g.group === groupName);
    const nonRequired = group.items.filter(c => !c.required);
    return nonRequired.length === 0 || nonRequired.every(c => this.selectedColumns[c.key]);
  }

  private findColumn(key: string) {
    for (const group of this.columnGroups) {
      const col = group.items.find(c => c.key === key);
      if (col) {
        return col;
      }
    }
    return null;
  }

  get totalColumns(): number {
    return this.columnGroups.reduce((n, g) => n + g.items.length, 0);
  }

  get selectedColumnsCount(): number {
    return Object.keys(this.selectedColumns).filter(k => this.selectedColumns[k]).length;
  }

  get activeColumns() {
    const cols = [];
    this.columnGroups.forEach(g => g.items.forEach(c => {
      if (this.selectedColumns[c.key]) {
        cols.push(c);
      }
    }));
    return cols;
  }

  switchPreviewTab(tab: PreviewTab) {
    this.previewTab = tab;
  }

  previewValue(row: any, key: string) {
    return row[key] !== undefined ? row[key] : '—';
  }

  get previewSkillRows() {
    return PREVIEW_SKILL_ROWS;
  }

  get schoolsInScope(): SchoolModel[] {
    return this.scope === 'all' ? this.allSchools : this.allSchools.filter(s => this.selected.has(s._id));
  }

  get totalStudents(): number {
    return this.schoolsInScope.reduce((sum, s) => sum + (s.numLicenses || 0), 0);
  }

  get totalSheets(): number {
    return Object.keys(this.sections).filter(k => this.sections[k]).length;
  }

  schoolInitials(name: string): string {
    if (!name) {
      return '';
    }
    return name.substring(0, 2).toUpperCase();
  }

  backToDetail() {
    this.router.navigate(['admin', 'schoolYears', this.schoolYearId, 'detail']);
  }

  private buildPayload(): ResearchExportPayload {
    const payload = new ResearchExportPayload();
    payload.scope = this.scope;
    payload.schoolIds = Array.from(this.selected);
    payload.includeSkillSummary = this.sections.skills;
    payload.skillGranularity = this.skillGranularity;
    payload.columns = Object.keys(this.selectedColumns).filter(k => this.selectedColumns[k]);
    payload.includeActivity = this.sections.activity;
    payload.activityPeriod = this.activityPeriod;
    payload.includeGroupSummary = this.sections.groups;
    payload.groupGranularity = this.groupGranularity;
    payload.includeSchoolName = this.includeSchoolName;
    payload.includeGroupName = this.includeGroupName;
    payload.excludeLowActivityStudents = this.excludeLowActivityStudents;
    return payload;
  }

  doExport() {
    if (this.scope === 'schools' && this.selected.size === 0) {
      this.modalSv.showAlertModal('No schools selected', 'Select at least one school, or switch to "All schools in year".');
      return;
    }
    if (this.totalSheets === 0) {
      this.modalSv.showAlertModal('Nothing to export', 'Enable at least one data section to include in the export.');
      return;
    }

    this.isExporting = true;
    this.exportSv.generateExport(this.schoolYearId, this.buildPayload()).subscribe(blob => {
      this.isExporting = false;
      const filename = `research-export-${this.schoolYear.name}-${this.schoolYearId}.xlsx`;
      saveAs(blob, filename);
    }, (err: ErrorModel) => {
      this.isExporting = false;
      this.modalSv.showTranslatedErrorModal(err);
    });
  }
}
